import { deleteNotify, postNotify } from '../../api';
import { transformSlots } from '../../transformers';
import eventTypes from '../../constants/eventTypes';

const { GENERAL_ADMISSION, SEATED } = eventTypes;
const eventTypeMap = {
  1: GENERAL_ADMISSION,
  2: SEATED,
};

const transformEventPackages = (packages = []) => {
  const mapResult = packages.map((curr) => {
    let availableQuantity = curr.slots.length;

    if (eventTypeMap[curr.event_type] === GENERAL_ADMISSION && !curr.sold_out) {
      availableQuantity = (curr.slots.length > 0) ? curr.slots[0].quantity.remaining : 0;
    }

    return {
      availableQuantity,
      title: curr.name,
      description: curr.whats_included,
      mandatoryAddOns: curr?.payment?.has_mandatory_addons || false,
      basePriceNumber: curr?.payment?.base ?? 0,
      price: `${curr.payment?.total_str ?? 0}`.replace(/\.00$/, ''),
      priceNumber: curr.payment?.total ?? 0,
      slots: transformSlots(
        curr.slots,
        {
          /* eslint-disable-next-line camelcase */
          hasAddOns: !!(curr.template?.item_ids?.length),
          /* eslint-disable-next-line camelcase */
          hasMenus: !!(curr.template?.menu_ids?.length),
          templateId: curr.template?.id,
          whatsIncluded: curr.whats_included,
          gatingErrors: curr.gating_errors,
        }
      ),
      isGda: curr.is_global_dining_access,
      soldOut: curr.sold_out && !availableQuantity,
      isPresaleSoldOut: curr.presale_sold_out,
    };
  });
  return mapResult;
};

const setEventNotify = (params) => postNotify({ struct_data: { notifies: [params] } }).then((data) => data);

const deleteEventNotify = (params) => deleteNotify(params).then((data) => data);

export {
  setEventNotify,
  deleteEventNotify,
  transformEventPackages,
};
